import Status from './status'
import addCustomer from'./addCustomer'

export default [Status,addCustomer]
